var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36163_74590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8.41833C0 4.00006 3.58172 0.418335 8 0.418335V0.418335C12.4183 0.418335 16 4.00006 16 8.41833V8.41833C16 12.8366 12.4183 16.4183 8 16.4183V16.4183C3.58172 16.4183 0 12.8366 0 8.41833V8.41833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -4.5,
    y: -4.08167,
    width: 25,
    height: 25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -4.5,
    y: -4.08167,
    width: 25,
    height: 25,
    stroke: "#EBEBEB"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.4183C4.13401 15.4183 1 12.2843 1 8.41833H-1C-1 13.3889 3.02944 17.4183 8 17.4183V15.4183ZM15 8.41833C15 12.2843 11.866 15.4183 8 15.4183V17.4183C12.9706 17.4183 17 13.3889 17 8.41833H15ZM8 1.41833C11.866 1.41833 15 4.55234 15 8.41833H17C17 3.44777 12.9706 -0.581665 8 -0.581665V1.41833ZM8 -0.581665C3.02944 -0.581665 -1 3.44777 -1 8.41833H1C1 4.55234 4.13401 1.41833 8 1.41833V-0.581665Z",
    fill: "#EBEBEB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36163_74590"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8.41833C0 4.00006 3.58172 0.418335 8 0.418335V0.418335C12.4183 0.418335 16 4.00006 16 8.41833V8.41833C16 12.8366 12.4183 16.4183 8 16.4183V16.4183C3.58172 16.4183 0 12.8366 0 8.41833V8.41833Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckOff);
export default __webpack_public_path__ + "static/media/check-off.791a7b668bf3a94af97d9ed9b3c7e2a6.svg";
export { ForwardRef as ReactComponent };